import type { IUtils } from '@date-io/core/IUtils'
import * as React from 'react'

import type { MaterialUiPickersDate } from '../typings/date'

import { useUtils } from './hooks/useUtils'

export interface WithUtilsProps {
  utils: IUtils<MaterialUiPickersDate>
}

export const withUtils = () => (Component: any) => {
  const WithUtils = (props: any) => {
    const utils = useUtils()

    return <Component utils={utils} {...(props as any)} />
  }

  WithUtils.displayName = `WithUtils(${Component.displayName || Component.name})`

  return WithUtils
}
